import { FC, MouseEvent } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { StackLayout } from '@progress/kendo-react-layout'

interface QuotationRequestBuildingFooterProps {
  displayMode: string
  nonCtrlFlg: boolean
  onHiddenBtnClick: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
  onSaveBtnClick: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
  onGoBackBtnClick: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
  onTempSaveBtnClick: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
}

export const QuotationRequestBuildingFooter: FC<
QuotationRequestBuildingFooterProps
> = (props) => {
  return (
    <>
      <div
        className="pcy-search-body-pane-footer pcy-control-box"
        style={{
          backgroundColor: '#FFFFFF'
        }}
      >
        <StackLayout gap={5} align={{ horizontal: 'end' }}>
          <Button onClick={props.onGoBackBtnClick}>戻る</Button>
          <Button onClick={props.onHiddenBtnClick}>
            {props.displayMode === '0' ? '非表示' : '全表示'}
          </Button>
          {!props.nonCtrlFlg && (
            <>
              <Button onClick={props.onTempSaveBtnClick} themeColor="primary">
              一時保存
              </Button>
              <Button onClick={props.onSaveBtnClick} themeColor="primary">
                登録
              </Button>
            </>
          )}
        </StackLayout>
      </div>
    </>
  )
}
